import forEach from "./customForEach";

const PHONE_MASK_OPTIONS = {
    mask: "+{7} (000) 000-00-00",
    prepare: (appended, masked) => {
        if (appended === "8" && masked.value === "") return "";
        return appended;
    },
};

function initPhoneMaskForModal(modal) {
    let phoneInput = modal.querySelectorAll(".phone-mask");
    forEach(phoneInput, function (index, value) {
        IMask(value, PHONE_MASK_OPTIONS);
    });
}

export default initPhoneMaskForModal;
